import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IDataSourceDefinitionProperty } from '../../../../../../shared/interfaces/data-source/data-source-definitions/data-source-property-definition.interface';
import { NewDataSourceDefinitionsService } from '../../../../../data-source/data-source-definitions/services/new-data-source-definitions.service';
import { LocalChartFilterChange } from '../../../../interfaces/tiles/local-chart-filter-change.interface';
import { LocalChartFilter } from '../../../../interfaces/tiles/local-chart-filter.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-tile-filters-select',
  templateUrl: './tile-filters-select.component.html',
  styleUrls: ['./tile-filters-select.component.scss'],
})
export class TileFiltersSelectComponent implements OnInit, OnDestroy {
  @Input() alias;
  @Input() localChartFilter: LocalChartFilter;

  @Output() filterChanged: EventEmitter<LocalChartFilterChange> = new EventEmitter();

  definitionProperty: IDataSourceDefinitionProperty;
  filterForm: FormGroup;
  options: any[] = [];

  get filterControl(): FormControl {
    return this.filterForm.get('filter') as FormControl;
  }

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private newDataSourceDefinitionsService: NewDataSourceDefinitionsService,
  ) {}

  async ngOnInit() {
    this.initForm();
    this.initOptions();
    await this.initLabel();
    this.initFilterChangesSubscription();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFilterChange(newFilterValue: number | null) {
    this.filterChanged.emit({
      localChartFilter: this.localChartFilter,
      newValue: newFilterValue,
    });
  }

  onValueReset(event: MouseEvent) {
    event.stopPropagation();
    this.filterControl.reset();
  }

  private async initLabel() {
    this.definitionProperty = await this.newDataSourceDefinitionsService.getPropertyByAliasAndName(
      this.alias,
      this.localChartFilter.property,
    );
  }

  private initForm() {
    this.filterForm = this.fb.group({
      filter: [''],
    });
  }

  private initOptions() {
    const { min, max } = this.localChartFilter;
    for (let i = min; i <= max; i++) {
      this.options.push(i);
    }
  }

  private initFilterChangesSubscription() {
    this.filterControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.onFilterChange(value);
    });
  }
}
